import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BillingHistoryComponent } from '@app/billing-history/billing-history.component';

const routes: Routes = [{ path: '', component: BillingHistoryComponent }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
